<template>
  <div>
    <div v-if="column === 'shipmentNumber'">
      <div>
        <div>
          <router-link class="shipment-link" :to="shipmentsFeedLink" target="_blank">
            {{ shipment.shipmentNumber }}
          </router-link>
        </div>
        <div v-if="shipment.adjustedShipmentNumber">
          <small class="text-success">
            Changed to
            {{ shipment.adjustedShipmentNumber }}
          </small>
        </div>
      </div>
    </div>
    <div v-if="column === 'createdAt'">
      <RowDate :date="shipment.createdAt" />
    </div>
    <div v-if="column === 'carrier'">
      <CarrierData :shipment="shipment" :only-icon="!!shipment.adjustedCarrierHandle" />
    </div>
    <div v-if="column === 'lastTrackingEventTime'">
      <RowDate :date="shipment.lastTrackingEventTime" />
    </div>
    <div v-if="column === 'lastTrackingEventStatus'">
      <TrackingStatusCell :shipment="shipment" />
    </div>
    <div v-if="column === 'user'">
      {{ shipment.company.name }}
    </div>
    <div v-if="column === 'recipient'">
      <div>
        {{ toAddressString(shipment.recipient) }}
      </div>

      <div>
        <small class="text-muted">
          {{ addressOwner(shipment.recipient) }}
        </small>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { Shipment } from '@/types/Models/Shipment'
import { defineComponent, computed, type PropType } from 'vue'
import { useAddressTransformers } from '@/composables/Address/useAddressTransformers'
import { STAFF_SHIPMENTS } from '@/types/router'
import RowDate from '@/views/Components/Elements/Table/RowDate.vue'
import CarrierData from '@/views/Components/Carrier/CarrierData.vue'
import TrackingStatusCell from '@/views/Components/Elements/Table/TrackingStatus.vue'

export default defineComponent({
  name: 'ForwardingRow',
  components: {
    TrackingStatusCell,
    CarrierData,
    RowDate,
  },
  props: {
    column: {
      type: String,
      required: true,
    },
    shipment: {
      type: Object as PropType<Shipment>,
      required: true,
    },
  },
  setup(props) {
    const { toAddressString, addressOwner } = useAddressTransformers()

    const shipmentsFeedLink = computed(() => ({
      name: STAFF_SHIPMENTS,
      query: {
        query: props.shipment.shipmentNumber,
      },
    }))

    return {
      toAddressString,
      addressOwner,
      shipmentsFeedLink,
    }
  },
})
</script>

<style lang="scss" scoped>
.shipment-link {
  text-decoration: underline;
  color: #058880;

  &:hover {
    text-decoration: none;
  }
}
</style>
